// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__SH4gB","title":"Info_title__33F_r","selects":"Info_selects__1Afv4","requiredAsterisk":"Info_requiredAsterisk__hIRJm"};